import React from "react";
import { useState, useEffect, useRef } from "react";
import { useGlobalContext } from "../context";

const SearchForm = () => {
  const { setSearchTerm } = useGlobalContext();
  const searchValue = useRef("");

  const searchCocktail = () => {
    setSearchTerm(searchValue.current.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <section className="search">
      <form className="search-form" onSubmit={handleSubmit}>
        <input
          type="text"
          id="name"
          ref={searchValue}
          onChange={searchCocktail}
          placeholder="Search for your favorite drinks!"
        />
      </form>
    </section>
  );
};

export default SearchForm;
